import { render, staticRenderFns } from "./SidebarActions.vue?vue&type=template&id=49359822&"
import script from "./SidebarActions.vue?vue&type=script&lang=js&"
export * from "./SidebarActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports